export default __webpack_public_path__ + "assets/celsius.e06a9dc8.svg";